import { dayFirstPluralLowercase } from 'owa-locstrings/lib/strings/dayfirstplurallowercase.locstring.json';
import { daySecondGenitivePluralLowercase } from './getLowercaseSingularPluralStrings.locstring.json';
import { daySingularLowercase } from 'owa-locstrings/lib/strings/daysingularlowercase.locstring.json';
import createSingularPluralStrings from 'owa-measurementunit-formatter/lib/createSingularPluralStrings';
import getSingularPluralExpressions from 'owa-measurementunit-formatter/lib/getSingularPluralExpressions';
import getUnitString from 'owa-measurementunit-formatter/lib/getUnitString';
import loc, { getCurrentCulture } from 'owa-localize';

/**
 * Returns the localized string for "day" or "days"
 * taking into account pluralization rules of different languages.
 */
export default function getPluralizedDayString(days: number) {
    const dayStrings = createSingularPluralStrings(
        loc(daySingularLowercase),
        loc(dayFirstPluralLowercase),
        loc(daySecondGenitivePluralLowercase)
    );
    const expressions = getSingularPluralExpressions(getCurrentCulture());
    return getUnitString(days, dayStrings, expressions);
}
